
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface BlogSearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export function BlogSearchBar({ searchTerm, onSearchChange }: BlogSearchBarProps) {
  return (
    <div className="relative w-full">
      <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-4 w-4 sm:h-5 sm:w-5 text-gray-400" />
      <Input
        type="text"
        placeholder="Pesquisar artigos..."
        className="pl-10 sm:pl-12 pr-4 py-3 sm:py-4 w-full text-sm sm:text-base lg:text-lg border-gray-300 focus:border-green-600 rounded-xl shadow-sm"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
}
